import { blackLight, blackMedium, grayMedium, whiteHard, whiteLight } from 'styleVars/getColors';

export const styles = (theme) => ({
  root: {
    width: '100%',
  },

  paper: {
    fontFamily: '"Open Sans", sans-serif',
    position: 'absolute',
    width: '240px',
    borderRadius: '15px',
    border: 'solid 1px #c5c5c5',
    boxShadow: 'none',
    padding: '20px',
    marginTop: '15px',
    overflow: 'visible',
    boxSizing: 'border-box',

    '&::before': {
      position: 'absolute',
      content: '""',
      display: 'block',
      bottom: '100%',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '0',
      height: '0',
      borderLeft: '8px solid transparent',
      borderRight: '8px solid transparent',
      borderBottom: '9px solid white',
      zIndex: 2,
    },

    '&::after': {
      position: 'absolute',
      content: '""',
      display: 'block',
      bottom: '100%',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '0',
      height: '0',
      borderLeft: '9px solid transparent',
      borderRight: '9px solid transparent',
      borderBottom: '10px solid #c5c5c5',
      zIndex: 1,
    },
  },

  inputRoot: {
    marginTop: '10px',
    width: '100%',
    fontFamily: '"Open Sans", sans-serif',
    border: '2px solid',
    borderColor: grayMedium,
    padding: '1px 10px',
    borderRadius: '8px',
    fontSize: '18px',
    lineHeight: '25px',
    color: blackMedium,
    background: whiteLight,

    '&::after, &::before': {
      content: 'none',
    },
  },

  inputEmpty: {
    color: grayMedium,
  },

  inputError: {
    borderColor: theme.palette.error.main,
  },

  disabled: {
    background: whiteHard,
    cursor: 'not-allowed !important',
    color: 'currentColor',
  },

  disabledWithAccessibility: {
    background: whiteHard,
    cursor: 'not-allowed !important',
    color: blackLight,
  },
});
